import { useTranslation } from "react-i18next";
import { useQuery, useQueryClient, useMutation } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

const STALE_TIME = Infinity;

export const useInvoiceTemplate = (config) => {
  const { t } = useTranslation();
  return useQuery({
    ...config,
    staleTime: STALE_TIME,
    queryKey: "invoice-template",
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/invoice-template`,
        signal,
      }),

    select: (data) => {
      return { ...data, tax_label_empty_value: t("Tax Number") };
    },
  });
};

export const useUpdateInvoiceTemplate = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/invoice-template`,
        method: "PUT",
        body: data,
      }),
    onSuccess: () => {
      client.invalidateQueries("invoice-template");
    },
  });
};
